// The look of every list table (the header band and cell truncation come from the theme):
// a quiet uppercase header, rows that read as clickable, figures in tabular digits. Row actions stay muted until the row is hovered.
export const datagridSx = {
  "& .RaDatagrid-headerCell": {
    height: 44,
    py: 0,
    px: "14px",
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 0.4,
    textTransform: "uppercase",
    color: "text.secondary",
    whiteSpace: "nowrap",
  },
  "& .RaDatagrid-rowCell": {
    height: 52,
    py: "6px",
    px: "14px",
    fontSize: 14,
    whiteSpace: "nowrap",
    fontVariantNumeric: "tabular-nums",
  },
  "& .RaDatagrid-row": { cursor: "pointer" },
  "& .RaDatagrid-row:last-of-type .RaDatagrid-rowCell": { borderBottom: 0 },
  "& .RaDatagrid-row:hover .row-actions": { opacity: 1 },
};
